import { render, staticRenderFns } from "./PageAdminOpportunitySettings.vue?vue&type=template&id=29848004"
import script from "./PageAdminOpportunitySettings.vue?vue&type=script&lang=js"
export * from "./PageAdminOpportunitySettings.vue?vue&type=script&lang=js"
import style0 from "./PageAdminOpportunitySettings.vue?vue&type=style&index=0&id=29848004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports